import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { WGLGeometryType as e } from "../enums.js";
import { createProgramDescriptor as t } from "../Utils.js";
import a from "./WGLGeometryBrush.js";
import { LabelMaterialKey as o } from "../materialKey/MaterialKey.js";

var n = function n(e) {
  return t(e.data, {
    geometry: [{
      location: 0,
      name: "a_pos",
      count: 2,
      type: 5122
    }, {
      location: 1,
      name: "a_id",
      count: 4,
      type: 5121
    }, {
      location: 2,
      name: "a_color",
      count: 4,
      type: 5121,
      normalized: !0
    }, {
      location: 3,
      name: "a_haloColor",
      count: 4,
      type: 5121,
      normalized: !0
    }, {
      location: 4,
      name: "a_texAndSize",
      count: 4,
      type: 5121
    }, {
      location: 5,
      name: "a_refSymbolAndPlacementOffset",
      count: 4,
      type: 5121
    }, {
      location: 6,
      name: "a_glyphData",
      count: 4,
      type: 5121
    }, {
      location: 7,
      name: "a_vertexOffset",
      count: 2,
      type: 5122
    }, {
      location: 8,
      name: "a_texCoords",
      count: 2,
      type: 5123
    }]
  });
};

var r = /*#__PURE__*/function (_a) {
  _inherits(r, _a);

  var _super = _createSuper(r);

  function r() {
    _classCallCheck(this, r);

    return _super.apply(this, arguments);
  }

  _createClass(r, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return e.LABEL;
    }
  }, {
    key: "drawGeometry",
    value: function drawGeometry(e, t, a, _r) {
      var i = e.context,
          s = e.painter,
          l = e.state,
          m = e.rendererInfo,
          c = o.load(a.materialKey),
          f = c.mapAligned ? 1 : 0;
      if (!f && Math.abs(t.key.level - Math.round(100 * e.displayLevel) / 100) >= 1) return;

      var _n = n(c),
          u = _n.bufferLayouts,
          d = _n.attributes,
          p = s.materialManager.getMaterialProgram(e, c, "materials/label", d, _r);

      e.context.setStencilFunction(514, 0, 255), i.useProgram(p), this._setSharedUniforms(p, e, t), s.textureManager.bindTextures(i, p, c);
      var y = 1 === f ? l.displayViewMat3 : l.displayMat3;
      this._setSizeVVUniforms(c, p, m, t), p.setUniform1f("u_mapRotation", Math.floor(l.rotation / 360 * 254)), p.setUniform1f("u_mapAligned", f), p.setUniformMatrix3fv("u_displayMat3", y), p.setUniform1f("u_opacity", 1), p.setUniform2fv("u_screenSize", e.state.size), p.setUniform1f("u_isHalo", 1), a.draw(i, u, d), p.setUniform1f("u_isHalo", 0), a.draw(i, u, d), i.setStencilTestEnabled(!0), i.setBlendingEnabled(!0);
    }
  }]);

  return r;
}(a);

export { r as default };